import {
  CheckboxGroupWrapper,
  MobileLayover,
  Window,
  isMobile,
} from '@kizi/comparator-components';
import { useCurrentStepIndex, useField, useForm } from '@kizi/comparator-core';
import { Button, Div, Label, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React, { useState } from 'react';

export const CombinationDiscount = ({ isFilter = false }) => {
  const wizardStepIndex = useCurrentStepIndex() ?? '';
  const { send, state } = useForm(wizardStepIndex);

  const mobileProvider = useField('mobileProvider');
  const mobileProviderValue = JSON.parse(mobileProvider?.value as string);
  const energySupplier = useField('energySupplier');
  const energySupplierValue = JSON.parse(energySupplier?.value as string);
  const [showModal, setShowModal] = useState(false);

  if (!send || !state) return <></>;

  const getDivProps = () => {
    return isFilter
      ? {}
      : {
          variant: 'primaryCard',
          mb: '3',
          p: '16px 24px!important',
          borderRadius: '24px',
        };
  };

  const _children = (
    <Div>
      <P variant="bodyImportant" fontSize="32px!important">
        {'Combinatiekorting'}
      </P>
      <P variant="footnoteRegular" color="main.5" mb={4}>
        {
          'Combineer je mobiele abonnement en je energie contract met je alles-in-1 abonnement en krijg extra korting op je maandprijs.'
        }
      </P>
      <P variant="bodyImportant">{'Mobiele provider'}</P>
      <CheckboxGroupWrapper
        id="Mobiele provider"
        _fieldName="overview.mobileProvider"
        options={[
          { label: 'Ben', value: 'Ben' },
          { label: 'Budget-Mobiel', value: 'Budget-Mobiel' },
          { label: 'Caiway', value: 'Caiway' },
          { label: 'Delta', value: 'Delta' },
          { label: 'hollandsnieuwe', value: 'hollandsnieuwe' },
          { label: 'KPN', value: 'KPN' },
          { label: 'Odido', value: 'Odido' },
          { label: 'Simyo', value: 'Simyo' },
          { label: 'Vodafone', value: 'Vodafone' },
          { label: 'Youfone', value: 'Youfone' },
        ]}
        selectedOptions={[]}
      />
      <P mt={1} variant="bodyImportant">
        {'Energieleverancier'}
      </P>
      <CheckboxGroupWrapper
        id="Energieleverancier"
        _fieldName="overview.energySupplier"
        options={[{ label: 'Budget energie', value: 'Budget energie' }]}
        selectedOptions={[]}
      />
      <Button
        mt={6}
        variant="primary"
        width="100%!important"
        onClick={() => setShowModal(false)}
      >
        {'Korting toevoegen'}
      </Button>
    </Div>
  );

  return (
    <Div {...getDivProps()}>
      <Label variant="heading" fontSize="24px">
        {'Combinatiekorting'}
      </Label>
      <P
        mb={isFilter ? 3 : 4}
        mt={!isFilter ? 2 : undefined}
        variant="captionRegular"
        color="main.5"
      >
        {
          'Voeg je mobiele provider en energieleverancier toe voor extra korting.'
        }
      </P>
      <Div
        mb={isFilter ? 3 : 4}
        display={
          [...mobileProviderValue, ...energySupplierValue].length
            ? 'block'
            : 'none'
        }
      >
        {[...mobileProviderValue, ...energySupplierValue].map((el) => (
          <P key={el} variant="footnoteRegular">
            {el}
          </P>
        ))}
      </Div>
      <Button
        variant="combinationDiscount"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <Div
          display="flex"
          alignItems="center"
          justifyContent="center"
          gridGap="8px"
        >
          <P color="#FFF" fontSize={3} fontWeight={1}>
            {'Toevoegen'}
          </P>
          <IconV2 name="plusCircle" size={24} />
        </Div>
      </Button>
      {isMobile() ? (
        <MobileLayover
          p={2}
          show={showModal}
          onClose={() => setShowModal(false)}
          noHorizontalPadding
        >
          {_children}
        </MobileLayover>
      ) : (
        <Window
          type="modal"
          show={showModal}
          onClose={() => setShowModal(false)}
          modalProps={{
            show: showModal,
            modalContainerDivProps: {
              width: '500px !important',
              pt: '0!important',
            },
            children: _children,
          }}
        >
          <P></P>
        </Window>
      )}
    </Div>
  );
};
